module.exports = __webpack_public_path__ + "img/yujing.7398da71.jpg";